// extracted by mini-css-extract-plugin
export default {"image":"ImageRadios_image__e--8-","layout":"ImageRadios_layout__KMFte","text":"ImageRadios_text__BBluv","radioHidden":"ImageRadios_radioHidden__mNZL+"};